import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { VerifyOtpPayload } from "./dto";
import { enumeratorClient } from "config/axios";
import PATHS from "config/paths";

export const passwordOtpVerify = (data: VerifyOtpPayload): Promise<{}> => {
  return enumeratorClient.httpClient.post(PATHS.enumerator.changePassword.verifyOtp, data);
};

export const useEnumeratorPasswordOtpVerify = () => {
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: async ({ data, token }: any, __, ___) => {
      await queryClient.invalidateQueries();
      notification.success({
        message: "Verified",
        description: "Otp successfully verified",
      });
    },

    mutationFn: passwordOtpVerify,
  });
};
